/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_SavedInputs */

const en_stats_saved = /** @type {(inputs: Stats_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const ko_stats_saved = /** @type {(inputs: Stats_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`절감`)
};

const ja_stats_saved = /** @type {(inputs: Stats_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削減`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Stats_SavedInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const stats_saved = /** @type {((inputs?: Stats_SavedInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_SavedInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stats_saved(inputs)
	if (locale === "ko") return ko_stats_saved(inputs)
	return ja_stats_saved(inputs)
});